// extracted by mini-css-extract-plugin
export default {"modalHeader":"SuccessModal_modalHeader__a25Ew","modalBody":"SuccessModal_modalBody__JlZ9K"};